export const PROPOSAL_OUTLINE_OWNER_TYPES = {
  MISC_ANALYSIS: "MISC_ANALYSIS",
  PROPOSAL: "PROPOSAL",
};
